/* Club 24 — zet de eigen uit-stand van het theme aan bij "beweging beperken".
 *
 * Het theme regelt animaties via attributen op <body>, gevuld vanuit de
 * theme-instellingen. Staat data-animate_images op "false", dan geldt
 * `.image-element { opacity: 1 }` en draait er geen fade. Die stand is door de
 * themebouwer bedacht en getest, dus die gebruiken we liever dan zelf 63
 * CSS-regels overschrijven.
 *
 * Draait bewust synchroon, direct na het openen van <body>, zodat de attributen
 * al goed staan voordat er iets in beeld komt. Geen defer, geen DOMContentLoaded:
 * dan zie je eerst een animatie beginnen en daarna stoppen, wat onrustiger is
 * dan hem helemaal niet tonen.
 */
(function () {
  if (!window.matchMedia) return;

  var vraag = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Alleen de attributen die daadwerkelijk verbergen of laten bewegen.
  // animate_underlines en animate_buttons blijven staan: dat zijn kleine
  // hover-signalen die aangeven dat iets klikbaar is, en die horen bij
  // bedienbaarheid en niet bij sfeer.
  var attributen = ['data-animate_sections', 'data-animate_images', 'data-transitions'];
  var bewaard = null;

  function pas_toe(beperken) {
    var body = document.body || document.getElementsByTagName('body')[0];
    if (!body) return;

    if (beperken) {
      if (bewaard === null) {
        bewaard = {};
        for (var i = 0; i < attributen.length; i++) {
          bewaard[attributen[i]] = body.getAttribute(attributen[i]);
        }
      }
      for (var j = 0; j < attributen.length; j++) {
        body.setAttribute(attributen[j], 'false');
      }
      body.setAttribute('data-c24-reduced-motion', 'true');
    } else if (bewaard) {
      // Terugzetten als iemand de voorkeur weer uitzet zonder te herladen.
      for (var k = 0; k < attributen.length; k++) {
        if (bewaard[attributen[k]] === null) {
          body.removeAttribute(attributen[k]);
        } else {
          body.setAttribute(attributen[k], bewaard[attributen[k]]);
        }
      }
      body.removeAttribute('data-c24-reduced-motion');
    }
  }

  pas_toe(vraag.matches);

  // De voorkeur kan tijdens het bezoek wijzigen. addEventListener is de moderne
  // vorm; addListener is er voor oudere Safari.
  if (vraag.addEventListener) {
    vraag.addEventListener('change', function (e) { pas_toe(e.matches); });
  } else if (vraag.addListener) {
    vraag.addListener(function (e) { pas_toe(e.matches); });
  }
})();
